import { isTodayOrTomorrow } from "../../../../services/helper"
import MissedCall from "./Notification/MissedCall"

const MissedCalls = ({ notifications, currentPage, setCurrentPage, setSelectedNotification, setCheckedKeys, getNotificationsUnifiedHandler,searchValue, limit, offset, filterValue, isCancelledRef }) => {
    return (
        Object.keys(notifications)?.map((date, index) => {
            let dateHeader = isTodayOrTomorrow(date)

            return (
                <div key={index} className="mb-4">
                    <label className="fs-4 fw-semibold text-black  mb-3">{dateHeader}</label>
                    {
                        notifications[date]?.map((notification, index) => {
                            return (
                                <MissedCall
                                    key={index}
                                    notification={notification}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setSelectedNotification={setSelectedNotification}
                                    setCheckedKeys={setCheckedKeys}
                                    getNotificationsUnifiedHandler={getNotificationsUnifiedHandler}
                                     searchValue={searchValue}
                                    limit={limit}
                                    offset={offset}
                                    filterValue={filterValue}
                                    isCancelledRef={isCancelledRef}
                                />
                            )
                        })
                    }
                </div>
            )
        })

    )
}

export default MissedCalls